import { Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import CommonDrawer from "../../drawer/CommonDrawer";
import { action, selectActionTxt } from "../../messages";
import Text from "../../text/Text";

function ActionsDrawer({ openDrawer, setOpenDrawer, actionOptions }) {
  return (
    <CommonDrawer
      anchor="bottom"
      open={openDrawer}
      onClose={() => setOpenDrawer(false)}
      className="action-drawer"
    >
      <Box className="action-drawer-container">
        <Text className="action-drawer-title">
          {action}
          <CloseIcon
            sx={{
              color: "#848B9E",
              height: "24px",
              width: "24px",
              cursor: "pointer",
            }}
            className="close-icon"
            onClick={() => setOpenDrawer(false)}
          />
        </Text>

        <Text className="action-drawer-subtitle">{selectActionTxt}</Text>
        <Box className="action-drawer-actions">
          {actionOptions?.map((option) => (
            <Box
              key={option.id}
              className="action-drawer-action-item"
              onClick={option?.action}
            >
              <Text size={16} font="bold" sx={{ color: option?.color }}>
                {option?.label}
              </Text>
            </Box>
          ))}
        </Box>
      </Box>
    </CommonDrawer>
  );
}

export default ActionsDrawer;
